var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"basic-text",class:_vm.bem('basic-text', { color: _vm.color, size: _vm.size, align: _vm.align, weight: _vm.weight })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }